var countries = require('json!../../../../../config/countries.json');

angular.module('account.tags.detail', [
  'security.authorization',
  'services.utility',
  'services.adminResource',
  'directives.serverError',
  'ui.bootstrap.dropdown',
  'services.formErrors',
  'ngFileUpload',
  'services.localizedMessages',
]);

angular.module('account.tags.detail').config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('account.tags.edit', {
      url: '/edit/:id',
      title: 'Account Tags / Details',
      views: {
        'main@': {
          template: require('./tag.tpl.html'),
          controller: 'AccountTagsDetailCtrl',
          resolve: {
            tag: ["$stateParams", "adminResource", function($stateParams, adminResource) {
              return adminResource.findTag($stateParams.id);
            }],
            roles: ["adminResource", function(adminResource) {
              return adminResource.searchRoles({});
            }],
            languages: ["adminResource", function(adminResource) {
              return adminResource.getLanguages()
            }]
          }
        }
      }
    });
}]);

angular.module('account.tags.detail').controller('AccountTagsDetailCtrl',
  ["$scope", "$route", "$location", "$log", "utility", "adminResource", "tag", "Tag", "formErrors", "growl", "dateFilter", "Upload", "user", "roles", "languages", "localizedMessages", "APP_IMG_URLS", function($scope, $route, $location, $log, utility, adminResource, tag, Tag, formErrors, growl,
    dateFilter, Upload, user, roles, languages, localizedMessages, APP_IMG_URLS) {
    $scope.localizedMessages = localizedMessages;
    var slugify = require('../../utils/slugify');

    $scope.dataLoaded = true;
    $scope.imgUrl = APP_IMG_URLS.base;
    $scope.mergeTags = [];

    $scope.countries = [];
    _.forIn(countries, function (value, key) {
      $scope.countries.push({
        _id: key,
        name: value
      });
    });

    $scope.rolesList = roles.data ? roles.data.map(function(role){
      return {
        _id: role._id,
        role_name: role.name,
        role_type: role.type,
        //role_sport: role.sport,
      }
    }) : [];
    $scope.languagesList = !!languages ? languages : [];

    $scope.$on('$locationChangeStart', function (event, next, current) {
        var answer = confirm("Are you sure you want to navigate away from this page");
        if (!answer) {
          event.preventDefault();
        }
    });

    $scope.$watch('avatar', function (file) {
      if (!file) return;
      $scope.uploadAvatar(file);
    });
    $scope.$watch('big_avatar', function (file) {
      if (!file) return;
      $scope.uploadBigAvatar(file);
    });

    $scope.uploadAvatar = function (file) {
      $scope.avatar_uploading = true;
      $scope.tag.avatar = file;
      Upload.upload({
        url: '/api/articles/upload',
        data: {file: file}
      }).then(function (resp) {
        $scope.avatar_uploading = false;
        $scope.tag.avatar = resp.data.filename;
        $scope.data.avatar_url = APP_IMG_URLS.base + resp.data.filename;
      }, function (resp) {
        $scope.avatar_uploading = false;
        $scope.thumbnail = null;
        console.log('Error status: ' + resp.status);
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
      });
    }

    $scope.uploadBigAvatar = function (file) {
      $scope.big_avatar_uploading = true;
      $scope.tag.big_avatar = file;
      Upload.upload({
        url: '/api/articles/upload',
        data: {file: file}
      }).then(function (resp) {
        $scope.big_avatar_uploading = false;
        $scope.tag.big_avatar = resp.data.filename;
        $scope.data.big_avatar_url = APP_IMG_URLS.base + resp.data.filename;
      }, function (resp) {
        $scope.big_avatar_uploading = false;
        $scope.thumbnail = null;
        console.log('Error status: ' + resp.status);
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
      });
    }

    $scope.generateThumb = function(file, rejFile){
      if(file === null && rejFile === undefined){
        growl.info('Max image size is 10MB!',3);
      }
    }

    $scope.addNewChoice = function($event) {
      $event.preventDefault()
      var newBio = {
        bio: "",
        rol: "",
        language: ""
      }
      if(!$scope.tag.bios) {
        $scope.tag.bios = [];
      }
      $scope.tag.bios.push(newBio);
    };

    $scope.removeChoice = function(index,$event) {
      $event.preventDefault()
      $scope.tag.bios.splice(index, 1);
    };
    $scope.closeDetailAlert = function () {
      $scope.detailAlerts = []
    }

    // local vars
    var createDraftIfNotExists = function(tag) {
      if(!$scope.checkIsDraftExists()) { // admin/user has no drafts
        var countryIndex = _.findIndex($scope.countries, { name:  tag.place.country});

        if(!!tag.drafts && tag.drafts.length > 4) {
          alert("Sorry, this tag already has maximum number of proposals. Please, try again later.")
          $scope.showOriginalVersion = true;
          return $scope.tagRoot;
        }

        return {
            avatar : !!tag.avatar ? tag.avatar : "",
            big_avatar : !!tag.big_avatar ? tag.big_avatar : "",
            bios : !!tag.bios ? angular.copy(tag.bios) : [],
            city : !!tag.place && !!tag.place.city ? tag.place.city : "",
            country : $scope.countries[countryIndex],
            created_at : new Date().toISOString(), //dateFilter(new Date(), 'yyyy-MM-dd HH:mm'),
            name : !!tag.name ? tag.name : "",
            shortName: '',
            officialName: '',
            oficial : !!tag.oficial ? tag.oficial : 0,
            place : {
              city: !!tag.place && !!tag.place.city ? tag.place.city : "",
              country: !!tag.place && !!tag.place.country ? tag.place.country : "",
            },
            sefriendly : !!tag.sefriendly ? tag.sefriendly : "",
            updated_at : !!tag.updated_at ? tag.updated_at : "",
            start_date : tag.start_date,
            end_date :   tag.end_date,
            organization : angular.isArray(tag.organization) ? tag.organization.map(function(e){
              return Object.assign(e, {text: e.name});
            }) : [],
            event :  angular.isArray(tag.event) ? tag.event.map(function(e){
              return Object.assign(e, {text: e.name});
            }) : [],
            role: tag.role,
            draftProposer: user.username
        };

      } else {
        var id = _.findIndex(tag.drafts, {draftProposer: user.username})
        if(!!$scope.draftProposer) {
          id = _.findIndex(tag.drafts, {draftProposer: $scope.draftProposer})
        }
        if(!!tag.drafts[id].place) {
          var countryIndex = _.findIndex($scope.countries, { name:  tag.drafts[id].place.country});
          tag.drafts[id].city =    !!tag.drafts[id].place.city ? tag.drafts[id].place.city : "";
          tag.drafts[id].country = !!tag.drafts[id].place.country ? $scope.countries[countryIndex] : "";
        }
        return tag.drafts[id];
      }
    }
    var deserializeData = function(data){
      deserializeAccountTag(data.record || data);
    };
    var deserializeAccountTag = function (data){
      $scope.tagRoot = data;
      var countryIndex = _.findIndex($scope.countries, { name:  data.place.country});
      $scope.tagRoot.country = $scope.countries[countryIndex]
      $scope.tagRoot.city = data.place.city
      $scope.tagRoot.organization = angular.isArray(data.organization) ? _.uniqBy(data.organization,'_id').map(function(e){
        return Object.assign(e, {text: e.name});
      }) : [];
      $scope.tagRoot.event =  angular.isArray(data.event) ? _.uniqBy(data.event,'_id').map(function(e){
        return Object.assign(e, {text: e.name});
      }) : [];
      $scope.tagRoot.role =  data.role;

      if(!$scope.isAdmin()) {
        $scope.showOriginalVersion = false;
        $scope.tag = createDraftIfNotExists(data);
      } else {
        $scope.tag = $scope.tagRoot;
      }

      $scope.data = {
        avatar_url: APP_IMG_URLS.base + $scope.tag.avatar,
        big_avatar_url: APP_IMG_URLS.base + $scope.tag.big_avatar
      }
    };
    $scope.submit = function () {
      if($scope.showOriginalVersion) {
        var oficialsave = 0;
        if($scope.tag.oficial){
          oficialsave = 1;
        }
        data = angular.copy($scope.tag);
        data.sefriendly = slugify(data.name);

        data.oficial = oficialsave;
        data.place = {}
        data.place.country = data.country ? data.country.name : ""
        data.place.city = data.city
        data.start_date = dateFilter(data.start_date, 'yyyy-MM-dd')
        data.end_date = dateFilter(data.end_date, 'yyyy-MM-dd')

        var nolang = data.bios.filter(function (item) {
          return !item.language
        })
        if (nolang.length > 0) {
          $scope.detailAlerts = []
          $scope.detailAlerts.push({
            type: 'danger',
            msg: 'Missing language'
          })
        } else {
          $scope.dataLoaded = false;

          // console.log( '>>>', data );
          Tag.update(data, function (result) {
            // console.log( '>>>', result);
            $scope.dataLoaded = true;
            growl.info('Tag saved!');
          }, formErrors.growlErrors);
        }
      } else {
        var data = angular.copy($scope.tagRoot); // published tag must not change
        data.hasDrafts = true;
        var id = _.findIndex(data.drafts, {draftProposer: $scope.isAdmin() ? $scope.draftProposer : user.username})
        if(id < 0) {
          id = data.drafts.push(angular.copy($scope.tag)) - 1;   // save draft as property of published tag
        }  else {
          data.drafts[id] = $scope.tag;
        }
        //data.draftProposer = user.username; // this propertiy is assigned on draft creation
        data.drafts[id].sefriendly = slugify(data.name);
        data.drafts[id].oficial = data.drafts[id].oficial ? 1 : 0;
        data.drafts[id].place = {}
        data.drafts[id].place.country = data.drafts[id].country ? data.drafts[id].country.name : ""
        data.drafts[id].place.city = data.drafts[id].city
        data.drafts[id].start_date = dateFilter(data.drafts[id].start_date, 'yyyy-MM-dd')
        data.drafts[id].end_date = dateFilter(data.drafts[id].end_date, 'yyyy-MM-dd')
        data.drafts[id].updated_at = new Date().toISOString(); //dateFilter(new Date(), 'yyyy-MM-dd HH:mm');

        var nolang = data.drafts[id].bios.filter(function (item) {
          return !item.language
        })
        if (nolang.length > 0) {
          $scope.detailAlerts = []
          $scope.detailAlerts.push({
            type: 'danger',
            msg: 'Missing language'
          })
        } else {
          $scope.dataLoaded = false;

          Tag.update(data, function (result) {
            $scope.dataLoaded = true;
            // update client's data indicating successfull creation of tag draft
            $scope.tagRoot.hasDrafts = true;
            $scope.tagRoot.drafts[id] = $scope.tag;
            $scope.tagRoot.drafts[id].created_at = $scope.tag.created_at = data.drafts[id].created_at;
            $scope.tagRoot.drafts[id].draftProposer = result.drafts[id].draftProposer;
            $scope.checkIsDraftExists(); // update draft related variables
            growl.info('Tag saved!');
          }, formErrors.growlErrors);
        }
      }

    };

    $scope.delete = function (tag) {
      if($scope.showOriginalVersion) {
        if (!confirm('Are you sure you want to delete this tag?')) {
          return;
        }
        Tag.delete({id: tag._id}, function (result) {
          setTimeout(function () {
            growl.info('Tag removed!');
            $location.path('/account/tags');
          }, 1000);
        }, formErrors.growlErrors);
      } else {
        if (!confirm('Are you sure you want to delete this draft tag?')) {
          return;
        }
        var data = angular.copy($scope.tagRoot);
        data.hasDrafts = false;
        var id = _.findIndex(data.drafts, {draftProposer: $scope.draftProposer})
        //data.draftProposer = user.username;
        data.drafts.splice(id,1);

        //data.proposer = user.username;
        $scope.dataLoaded = false;

          Tag.update(data, function (result) {
            $scope.dataLoaded = true;
            // update client's data indicating successfull deletion of tag draft
            $scope.tagRoot.hasDrafts = false;
            $scope.tagRoot.drafts.splice(id,1);
            $scope.checkIsDraftExists(); // update draft related variables
            $scope.showOriginalVersion = true;
            $scope.switchViewMode(true);
            growl.info('Draft is removed!');
          }, formErrors.growlErrors);
      }
    };
    $scope.doHumanReadableDateString = function(d) {
      return dateFilter(d, 'yyyy-MM-dd HH:mm')
    }

    $scope.showOriginalVersion = true;
    $scope.isDraftExists = false;
    $scope.draftProposedString = "";
    $scope.draftProposer = false;

    /** checkIsDraftExists
     * check tagRoot for defined draft subdocument, draft.name and valid draft.created_at date
     */
    $scope.checkIsDraftExists = function() {
      var id = _.findIndex($scope.tagRoot.drafts, {draftProposer: user.username})
      var $s = $scope;
      $s.isDraftExists = $s.isAdmin() ? $s.tagRoot.hasDrafts && $s.tagRoot.drafts.length > 0 : (id >= 0); //!(Object.keys(tag.draft).length === 0 && tag.draft.constructor === Object)
      return $scope.isDraftExists;
    }

    $scope.switchViewMode = function(showOriginalVersion, draftProposer) {
      $scope.showOriginalVersion = showOriginalVersion;
      $scope.draftProposer = draftProposer;
      if($scope.showOriginalVersion) {
        $scope.tag = $scope.tagRoot;
      } else {
        var draft = createDraftIfNotExists($scope.tagRoot);
        if($scope.isAdmin()) {
          if(!!$scope.tag.drafts && !$scope.tag.draftProposer) { // save original only if we switch from original to draft
            $scope.tagRoot = $scope.tag;
          }
        } else {
          $scope.tagRoot = $scope.tag;
        }
        $scope.tag = draft;
        $scope.data = {
          avatar_url: APP_IMG_URLS.base + $scope.tag.avatar,
          big_avatar_url: APP_IMG_URLS.base + $scope.tag.big_avatar
        }
        $scope.tag.organization = angular.isArray(draft.organization) ? _.uniqBy(draft.organization,'_id').map(function(e){
          return Object.assign(e, {text: e.name});
        }) : [];
        $scope.tag.event =  angular.isArray(draft.event) ? _.uniqBy(draft.event,'_id').map(function(e){
          return Object.assign(e, {text: e.name});
        }) : [];
      }
    }
    $scope.canEdit = function() {
      return user.permissions.is_admin || !$scope.showOriginalVersion;
    }
    $scope.isAdmin = function() {
      return user.permissions.is_admin;
    }

    $scope.applyDraft = function(tag) {
      if($scope.isAdmin()) {
        if($scope.tagRoot.drafts.length > 0 && confirm("Are you sure you want to apply this draft and delete all others")) {
          // save original
          $scope.tagRoot.drafts = [
            {
              avatar : $scope.tagRoot.avatar,
              big_avatar : $scope.tagRoot.big_avatar,
              city : $scope.tagRoot.city,
              name : $scope.tagRoot.name,
              shortName : $scope.tagRoot.shortName,
              officialName : $scope.tagRoot.officialName,
              oficial : $scope.tagRoot.oficial,
              sefriendly : $scope.tagRoot.sefriendly,
              updated_at : $scope.tagRoot.updated_at,
              created_at : $scope.tagRoot.created_at,
              start_date : $scope.tagRoot.start_date,
              end_date : $scope.tagRoot.end_date,
              place : angular.copy($scope.tagRoot.place),
              country : $scope.tagRoot.country,
              bios : angular.copy($scope.tagRoot.bios),
              organization: angular.copy($scope.tagRoot.organization),
              event: angular.copy($scope.tagRoot.event),
              role: $scope.tagRoot.role,
              draftProposer: user.username
            }
          ];
          $scope.tag._id =  $scope.tagRoot._id; // ensure tagRoot's id will not change after submit
          $scope.tagRoot.avatar = $scope.tag.avatar;
          $scope.tagRoot.big_avatar = $scope.tag.big_avatar;
          $scope.tagRoot.city = $scope.tag.city;
          $scope.tagRoot.name = $scope.tag.name;
          $scope.tagRoot.shortName = $scope.tag.shortName;
          $scope.tagRoot.officialName = $scope.tag.officialName;
          $scope.tagRoot.oficial = $scope.tag.oficial;
          $scope.tagRoot.sefriendly = $scope.tag.sefriendly;
          $scope.tagRoot.updated_at = $scope.tag.updated_at;
          $scope.tagRoot.created_at = $scope.tag.created_at;
          $scope.tagRoot.start_date = $scope.tag.start_date;
          $scope.tagRoot.end_date = $scope.tag.end_date;
          $scope.tagRoot.place = angular.copy($scope.tag.place);
          $scope.tagRoot.country = $scope.tag.country;
          $scope.tagRoot.bios = angular.copy($scope.tag.bios);
          $scope.tagRoot.organization = angular.copy($scope.tag.organization);
          $scope.tagRoot.event = angular.copy($scope.tag.event);
          $scope.tagRoot.role = $scope.tag.role;
          $scope.showOriginalVersion = true;

          $scope.submit();
        }
      }
    }

    $scope.loadOrganizations = function (query) {
      return adminResource.searchTags({type: 'organization'}).then(function (organizationTags) {
        if (!organizationTags) return [];
        var searchName = query.toLowerCase();
        return organizationTags.data.filter(function(o){
          var orgName = o.name.toLowerCase();
          var tagName = $scope.tag.name.toLowerCase();
          return orgName !== tagName && ( orgName.indexOf(searchName) > -1 );
        }).map(function (o) {
          return {
            _id: o._id,
            name: o.name,
          }
        })
      });
    };

    $scope.loadEvents = function (query) {
      return adminResource.searchTags({type: 'event'}).then(function (eventTags) {
        if (!eventTags) return [];
        var searchName = query.toLowerCase();
        return eventTags.data.filter(function(e){
          var evntName = e.name.toLowerCase();
          var tagName = $scope.tag.name.toLowerCase();
          return evntName !== tagName && ( evntName.indexOf(searchName) > -1 );
        }).map(function (e) {
          return {
            _id: e._id,
            name: e.name,
          }
        })
      });
    };

    $scope. loadTags= function (query) {
      return Tag.search({q: query}).$promise.then(function (tags) {
        if (!tags) return [];
        return tags.map(function (tag) {
          return {
            _id: tag._id,
            text: tag.nametag,
            name: tag.nametag,
            oficial: tag.oficial,
            sefriendly: tag.name
          }
        })
      });
    };

    $scope.runMergeTag = function(tags) {
      $scope.dataLoaded = false;
      Tag.mergeTags({
        tagId: $scope.tag._id,
        tags: $scope.mergeTags.map( function(t) { return t._id; })
      }, function () {
        $scope.dataLoaded = true;
        $scope.mergeTags = [];
      }, function (e) {
        $scope.dataLoaded = true;
        console.error(e);
      });
    }


    deserializeData(tag);
    $scope.checkIsDraftExists();
  }]);



// WEBPACK FOOTER //
// ./client/src/app/account/tags/tag.js